import { IAccount } from '@wot/typings';
import xhr from '../utils/fetch';

const login = async (email: string, password: string) => {
  return await xhr({
    url: `/auth/email-password`,
    method: 'POST',
    body: { email, password, role: 'admin' }
  })
    .then((res) => res)
    .catch((err) => {
      throw err;
    });
};

const authStatus = async (): Promise<IAccount> => {
  return await xhr({
    url: `/authStatus`,
    method: 'GET'
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

const logout = async () => {
  return await xhr({
    url: `/logout`,
    method: 'POST'
  })
    .then((res) => res)
    .catch((err) => {
      throw err;
    });
};

const authApi = {
  login,
  authStatus,
  logout
};

export default authApi;
